import React from 'react';
import {
  InputField,
  ListItem,
} from 'vindi-ds-components';

import handleCEP from '@utils/handle_cep';
import templates from '../templates.json';

function getField(item) {
  switch (item.field.name) {
    case 'zipcode': return <FieldZipCode />;
    case 'state': return <FieldState />;
    case 'city': return <FieldAddress name={item.field.name} label={item.field.label} helperText={item.field.helperText} />;
    case 'street': return <FieldAddress name={item.field.name} label={item.field.label} helperText={item.field.helperText} />;
    case 'number': return <FieldAddress number name={item.field.name} label={item.field.label} helperText={item.field.helperText} />;
    case 'additional_details': return <FieldAddress name={item.field.name} label={item.field.label} helperText={item.field.helperText} />;
    case 'neighborhood': return <FieldAddress name={item.field.name} label={item.field.label} helperText={item.field.helperText} />;
    default: return (
      <InputField
        label={item.field.label}
        name={item.field.name}
        helperText={item.field.helperText}
      />
    );
  }
}

export default getField;

function FieldZipCode() {
  return (
    <InputField
      label='CEP'
      name='address_attributes.zipcode'
      handleChange={(value) => handleCEP(value, true)}
      mask='cep'
    />
  );
}

function FieldAddress({
  name, label, helperText,
}) {
  return (
    <InputField
      name={`address_attributes.${name}`}
      label={label}
      helperText={helperText}
    />
  );
}

function FieldState() {
  return (
    <InputField label='Estado' name='address_attributes.state' placeholder='' select>
      {Object.entries(templates.states).map(([code, name]) => (
        <ListItem value={code} key={code}>{name}</ListItem>
      ))}
    </InputField>
  );
}
